/**
 * PK信息面板
 */

import React from 'react';
import styled from 'styled-components';
import cls from 'classnames';
import { observer } from 'mobx-react';

import { appClient, browser, user, utils } from '@/lib';
import { UiModal, UiToast } from '@/components';
import { useGlobalStore } from '@/stores';
import SvgaPlayer from '@/modules/party/ui/svga';
import { room } from '@/modules/widgets/lib';

import gamesFightStore from '../store';
import PkBoardUsers from './pk-board-users';
import PkBoardTime from './pk-board-time';

const PkBoard = observer(() => {
  const { isQtClientReady } = useGlobalStore();
  const { info } = gamesFightStore.useStore();
  const { pkCamps = [], nowTimestamp, pkEndTimestamp } = info;
  const [left = {}, right = {}] = pkCamps;

  const barStyle = {
    width: utils.toPercent(left.score, right.score, true),
  };

  const handleCompInfoClick = (e) => {
    const { comp } = e.currentTarget.dataset;
    if (comp !== 'right' || browser.memeClient) {
      return;
    }
    if (room.isRoomOwner()) {
      UiToast.text('当前正在PK，无法跳转');
      return;
    }
    if (room.isMicStar(user.getUserId())) {
      UiToast.text('当前在麦上，无法跳转');
      return;
    }
    const isParty = right.roomType === 6;

    UiModal.confirm(
      '提示',
      `是否前往 ${right.nickname} ${isParty ? '派对' : '房间'}`,
      () => {
        if (isQtClientReady) {
          if (isParty) {
            appClient.redirectParty(right.roomId);
          } else {
            appClient.redirectRoom(right.roomId);
          }
          appClient.closeWindow();
        } else {
          location.href = `/${right.roomId}`;
        }
      },
      null,
      `前往${isParty ? '派对' : '房间'}`,
      '取消',
    );
  };

  return (
    <Wrap className="pk-board">
      <div className="pk-info">
        {['left', 'right'].map((comp, compIdx) => {
          const item = pkCamps[compIdx] || {};
          return (
            <div
              key={comp}
              className={`pk-info-meat pk-info-meat-${comp}`}
              data-comp={comp}
              onClick={handleCompInfoClick}
            >
              <img
                className="pk-info-avatar"
                src={item.pic || 'https://img.sumeme.com/3/3/1559108259459.png'}
              />
              <div>
                <p className="pk-info-nick text-overflow">
                  {item.nickname || '昵称'}
                </p>
                <span className="pk-info-value">
                  {utils.formatNum(item.score)}
                </span>
              </div>
            </div>
          );
        })}
        <div className="pk-info-bar">
          <p className="pk-info-bar-con" style={barStyle}></p>
          <div className="pk-info-bar-split">
            <SvgaPlayer
              loops={0}
              className={cls('pk-split-svaga')}
              url="https://img-photo.sumeme.com/22/6/1689565222998_5541_5541.svga"
            />
          </div>
        </div>
      </div>
      <PkBoardTime nowTime={nowTimestamp} endTime={pkEndTimestamp} />
      <PkBoardUsers left={left.items} right={right.items} />
    </Wrap>
  );
});

const Wrap = styled.div`
  box-sizing: border-box;
  padding: 8px 8px 0;
  position: relative;
  color: #fff;
  .pk-info {
    position: relative;
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-meat {
      display: flex;
      position: relative;
      z-index: 2;
    }
    &-meat-right {
      display: flex;
      text-align: right;
      flex-direction: row-reverse;
      cursor: pointer;
      .pk-info-avatar {
        border-color: #64fcfc;
        margin: 0 0 0 4px;
      }
    }
    &-avatar {
      width: 34px;
      height: 34px;
      border: 1px solid #fc52ff;
      border-radius: 100%;
      margin: 0 4px 0 0;
    }
    &-nick {
      display: block;
      line-height: 18px;
      max-width: 140px;
    }
    &-value {
      position: relative;
      top: 1px;
    }
    &-bar {
      overflow: hidden;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      height: 16px;
      width: 94%;
      display: flex;
      flex-wrap: nowrap;
      background-color: #42c3ff;
      &-con {
        height: 100%;
        min-width: 15%;
        max-width: 85%;
        transition: width 250ms ease;
        background-color: #fc52ff;
      }
      &-split {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        width: 0;
        height: 16px;
        &::after,
        &::before {
          position: absolute;
          content: '';
          display: block;
          width: 136px;
          height: 16px;
          background: url(${require('../images/bg-blue-bar.png')}) no-repeat
            left / contain;
        }
        &::before {
          left: -136px;
          background-image: url(${require('../images/bg-red-bar.png')});
          background-position: right;
        }
      }
    }
  }
  .pk-split-svaga {
    position: relative;
    flex: 0 0 50px;
    width: 50px;
    height: 22px;
    z-index: 2;
    left: -25px;
    top: 0px;
  }
`;

export default PkBoard;
